import { Directive, ElementRef, Input, Optional, Renderer2, Self } from '@angular/core';
import { FormGroupDirective, NgControl } from '@angular/forms';
import { MatChipInput } from '@angular/material/chips';
import { Observable, Subscription } from 'rxjs';

@Directive({
  selector: 'input[irdClearInvalidAutocomplete]',
  standalone: true,
})
//implements OnInit, OnDestroy
export class ClearInvalidAutocompleteDirective<T = any> {
  @Input() options: T[] | Observable<T[]> = [];
  @Input() matchProp?: keyof T;
  @Input() fallbackControlsToReset: string[] = [];

  private resolvedOptions: T[] = [];
  private sub?: Subscription;

  constructor(
    @Optional() private formGroupDirective: FormGroupDirective,
    @Self() @Optional() private ngControl: NgControl,
    private el: ElementRef<HTMLInputElement>,
    private renderer: Renderer2,
    @Optional() private chipInput?: MatChipInput,
  ) {}

  // ngOnInit(): void {
  //   if (isObservable(this.options)) {
  //     this.sub = this.options.subscribe((data) => (this.resolvedOptions = data ?? []));
  //   } else {
  //     this.resolvedOptions = this.options ?? [];
  //   }
  // }

  // @HostListener('focusout')
  // onFocusOut(): void {
  //   const control = this.ngControl?.control as FormControl | null;
  //   if (!control) {
  //     return;
  //   }

  //   if (!this.matchProp && this.resolvedOptions.length > 0) {
  //     const first: any = this.resolvedOptions[0];
  //     if (first && typeof first === 'object') {
  //       const candidate = Object.keys(first).find((k) => {
  //         const v = first[k];
  //         return typeof v === 'string' || typeof v === 'number';
  //       });
  //       if (candidate) {
  //         this.matchProp = candidate as keyof T;
  //       }
  //     }
  //   }

  //   const parentFg = this.formGroupDirective?.form ?? null;
  //   const name = this.ngControl?.name ? String(this.ngControl.name) : undefined;

  //   let formGroup: FormGroup;
  //   let controlName: string;

  //   if (parentFg && name && parentFg.contains(name)) {
  //     formGroup = parentFg;
  //     controlName = name;
  //   } else {
  //     formGroup = new FormGroup({ dummy: control });
  //     controlName = 'dummy';
  //   }

  //   normalizeAutocompleteValue(formGroup, controlName, this.resolvedOptions, this.matchProp, this.fallbackControlsToReset);

  //   const v = control.value;
  //   if (v === '' || v == null) {
  //     this.renderer.setProperty(this.el.nativeElement, 'value', '');
  //     this.chipInput?.clear?.();
  //   }
  // }

  // ngOnDestroy(): void {
  //   this.sub?.unsubscribe();
  // }
}
